<template>
  <head-panel>
    <template v-slot:body>Баланси</template>
  </head-panel>

  <div class="wrapper">

    <div class="filter">
      <div class="item search">
        <SearchFilter
            label="Пошук"
            :icon="true"
            name="search"
            path="balance"
        />
      </div>
      <div class="item">
        <DateRangeFilter v-model="filter.dateRange" :updateRoute="true" path="/balance"/>
      </div>
    </div>

    <table class="table">
      <thead>
      <tr>
        <th scope="col">UUID</th>
        <th scope="col">Сума</th>
        <th scope="col">Валюта</th>
        <th scope="col">Опис</th>
        <th scope="col">Створений</th>
        <th scope="col"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="item in items" :key="item">
        <td>{{ item.uuid }}</td>
        <td>{{ $filters.price(item.amount / 100) }} {{item.currency}}</td>
        <td>{{item.currency}}</td>
        <td>{{ item.description }}</td>
        <td>{{ $filters.dateTime(item.createdAt) }}</td>
        <td class="actions">
          <router-link :to="'/balance/'+item.uuid">Деталі</router-link>
          <router-link :to="'/transaction?search='+item.uuid">Транзакції</router-link>
        </td>
      </tr>
      </tbody>
    </table>

    <Pagination
        :current-page="pagination.page"
        :total-pages="pagination.total"/>

  </div>
</template>

<script>
import Http from "../../lib/Http";
import HeadPanel from "../../components/HeadPanel";
import Pagination from "../../components/Pagination";
import SearchFilter from "../../components/SearchFilter";
import DateRangeFilter from "@/components/DateRangeFilter.vue";

export default {
  name: "BalanceList",
  components: {
    HeadPanel, Pagination, SearchFilter, DateRangeFilter
  },
  created() {
    this.fetch();
  },
  watch: {
    $route(n, o) {
      if (n.path === o.path)
        this.fetch();
    }
  },
  data() {
    return {
      items: [],
      filter: {
        dateRange: []
      },
      pagination: {
        page: 0,
        total: 0
      },
    }
  },
  methods: {
    fetch: function () {
      Http
          .get(this.$route.fullPath)
          .then((res) => {
            this.items = res.content;
            this.pagination.page = res.origin.headers.get("X-Current-Page") * 1;
            this.pagination.total = res.origin.headers.get("X-Page-Count") * 1;
          });
    }
  }
};
</script>

<style scoped>
.search {
  width: 340px;
}

</style>